<template>
  <ul class="vx-timeline">
    <popup-add-action ref="popupAddAction" />
    <li
      v-for="item in automation.actions"
      :key="item.id"
      class="cursor-pointer"
      @click="$refs.popupAddAction.show(automationId, item)"
    >
      <div
        class="timeline-icon"
        :class="`bg-${actionStyling[item._type].color}`"
      >
        <feather-icon
          :icon="actionStyling[item._type].icon"
          svgClasses="text-white stroke-current w-5 h-5"
        />
      </div>
      <div class="timeline-info">
        <p class="font-semibold">
          <component v-bind:is="item._type + 'Description'" :action="item" />
        </p>
        <span v-if="item.conditions.length > 0" class="activity-desc">
          <!--<component
            v-for="(condition, idx) in item.conditions"
            :key="idx"
            :idx="idx"
            v-bind:is="condition._type + 'Description'"
            :condition="condition"
        />-->{{ item.conditions.length }} conditions apply</span
        >
      </div>
      <small class="text-grey activity-e-time">{{
        item.delay === 0
          ? "Immediately"
          : "After " + humanizeDuration(item.delay, { largest: 4 })
      }}</small>
    </li>
    <li
      class="cursor-pointer"
      v-if="allowNewAction"
      @click="$refs.popupAddAction.show(automationId)"
    >
      <div class="timeline-icon bg-success outline">
        <feather-icon
          icon="PlusIcon"
          svgClasses="text-white stroke-current w-5 h-5"
        />
      </div>
      <div class="timeline-info pt-2">
        <p class="font-semibold">New action</p>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";
import parse from "parse-duration";
import humanizeDuration from "humanize-duration";
import PopupAddAction from "./popupAddAction.vue";
import AddLabelActionDescription from "./AddLabelActionDescription.vue";
import SendMailActionDescription from "./SendMailActionDescription.vue";
import SendSmsActionDescription from "./SendSmsActionDescription.vue";
import AddPointsActionDescription from "./AddPointsActionDescription.vue";
import CreateNightpayVoucherActionDescription from "./CreateNightpayVoucherActionDescription.vue";
import HasReadMailConditionDescription from "./Conditions/HasReadMailConditionDescription.vue";
import HasClickedMailConditionDescription from "./Conditions/HasClickedMailConditionDescription.vue";
import HasLabelConditionDescription from "./Conditions/HasLabelConditionDescription.vue";
import HasConsentConditionDescription from "./Conditions/HasConsentConditionDescription.vue";
export default {
  components: {
    PopupAddAction,
    SendMailActionDescription,
    AddLabelActionDescription,
    SendSmsActionDescription,
    HasReadMailConditionDescription,
    AddPointsActionDescription,
    CreateNightpayVoucherActionDescription,
    HasLabelConditionDescription,
    HasClickedMailConditionDescription,
    HasConsentConditionDescription,
  },
  name: "action-timeline",
  props: ["automationId", "allowNewAction"],
  data() {
    return {
      parse,
      humanizeDuration,
    };
  },
  computed: {
    ...mapGetters({
      actionStyling: "automations/actionStyling",
    }),
    automation() {
      return this.$store.getters["automations/automation"](this.automationId);
    },
  },
  methods: {},
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
